module.exports = __webpack_public_path__ + "static/img/pay_success.7c065615.svg";